var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReadActivity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 49.015,
    height: 37.406,
    viewBox: "0 0 49.015 37.406",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "open-book",
    transform: "translate(0 -60.629)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_937",
    "data-name": "Caminho 937",
    d: "M91.4,208.328a21.208,21.208,0,0,0-8.9-.536l-3.647.552a.718.718,0,0,0,.107,1.428.732.732,0,0,0,.108-.008l3.647-.552a19.78,19.78,0,0,1,8.3.5.718.718,0,0,0,.384-1.384Z",
    transform: "translate(-70.749 -132.854)",
    fill: "#d4af37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_938",
    "data-name": "Caminho 938",
    d: "M78.957,256.593a.732.732,0,0,0,.108-.008l3.647-.552a19.85,19.85,0,0,1,6.842.154.718.718,0,0,0,.279-1.409,21.283,21.283,0,0,0-7.336-.165l-3.647.552a.718.718,0,0,0,.106,1.428Z",
    transform: "translate(-70.75 -175.195)",
    fill: "#d4af37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_939",
    "data-name": "Caminho 939",
    d: "M91.076,301.939a21.2,21.2,0,0,0-8.9-.536l-3.647.552a.718.718,0,0,0,.107,1.428.732.732,0,0,0,.108-.008l3.647-.552a19.774,19.774,0,0,1,8.3.5.718.718,0,0,0,.384-1.384Z",
    transform: "translate(-70.459 -217.504)",
    fill: "#d4af37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_940",
    "data-name": "Caminho 940",
    d: "M304.9,114.463l-3.647-.552a21.2,21.2,0,0,0-8.9.536.718.718,0,0,0,.384,1.384,19.778,19.778,0,0,1,8.3-.5l3.647.552a.718.718,0,0,0,.215-1.42Z",
    transform: "translate(-263.894 -47.961)",
    fill: "#d4af37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_941",
    "data-name": "Caminho 941",
    d: "M292.549,162.656a.72.72,0,0,0,.192-.026,19.779,19.779,0,0,1,8.3-.5l1.056.16a.718.718,0,0,0,.215-1.42l-1.056-.16a21.206,21.206,0,0,0-8.9.536.718.718,0,0,0,.192,1.41Z",
    transform: "translate(-263.894 -90.28)",
    fill: "#d4af37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_942",
    "data-name": "Caminho 942",
    d: "M301.259,254.5a21.2,21.2,0,0,0-8.9.536.718.718,0,1,0,.384,1.384,19.777,19.777,0,0,1,8.3-.5l1.056.16a.718.718,0,0,0,.215-1.42Z",
    transform: "translate(-263.895 -175.091)",
    fill: "#d4af37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_943",
    "data-name": "Caminho 943",
    d: "M292.1,209.427a19.778,19.778,0,0,1,8.3-.5l3.647.552a.718.718,0,0,0,.215-1.42l-3.647-.552a21.2,21.2,0,0,0-8.9.536.718.718,0,0,0,.384,1.384Z",
    transform: "translate(-263.314 -132.597)",
    fill: "#d4af37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_944",
    "data-name": "Caminho 944",
    d: "M304.584,301.671l-3.647-.552a21.2,21.2,0,0,0-8.9.536.718.718,0,0,0,.384,1.384,19.778,19.778,0,0,1,8.3-.5l3.647.552a.718.718,0,0,0,.215-1.42Z",
    transform: "translate(-263.604 -217.247)",
    fill: "#d4af37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_945",
    "data-name": "Caminho 945",
    d: "M47.093,64.509H45.652V62.646a.718.718,0,0,0-.61-.71l-6.015-.911a34.51,34.51,0,0,0-14.483.873l-.011,0-.011,0a34.508,34.508,0,0,0-14.483-.873l-6.015.911a.718.718,0,0,0-.61.71v1.863H1.921A1.924,1.924,0,0,0,0,66.43v1.913a.718.718,0,0,0,1.436,0V66.43a.486.486,0,0,1,.485-.485H3.413V91.176a.718.718,0,0,0,.824.71l6.1-.913a33.071,33.071,0,0,1,14,.893.719.719,0,0,0,.391,0,33.071,33.071,0,0,1,14-.893l6.1.913a.718.718,0,0,0,.824-.71V65.945h1.441a.486.486,0,0,1,.485.485V93.492a.486.486,0,0,1-.485.485H36.442a.718.718,0,1,0,0,1.436H47.093a1.924,1.924,0,0,0,1.921-1.921V66.43a1.924,1.924,0,0,0-1.921-1.921ZM15.949,62.073q1.492.031,2.977.2v8.393l-.894-.848a.718.718,0,0,0-.9-.069l-1.179.817ZM15.29,89.166a34.885,34.885,0,0,0-5.17.387l-5.271.789V65.234s0,0,0-.007,0,0,0-.007V63.263l5.4-.818a33.511,33.511,0,0,1,4.259-.371V65.74a21.438,21.438,0,0,0-2.827.237l-3.647.552a.718.718,0,0,0,.107,1.428.733.733,0,0,0,.108-.008L11.9,67.4a19.954,19.954,0,0,1,2.612-.221v3.045a21.407,21.407,0,0,0-2.827.237l-3.647.552a.718.718,0,0,0,.107,1.428.733.733,0,0,0,.108-.008l3.647-.552a19.954,19.954,0,0,1,2.612-.221v.278a.718.718,0,0,0,1.127.59l1.827-1.266,1.683,1.6a.718.718,0,0,0,1.212-.521V62.463a33.493,33.493,0,0,1,3.453.73V90.24a34.458,34.458,0,0,0-8.525-1.073Zm28.926,1.176-5.271-.789a34.472,34.472,0,0,0-13.694.686V63.193a33.072,33.072,0,0,1,13.561-.749l5.4.818Z",
    transform: "translate(0 0)",
    fill: "#d4af37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_946",
    "data-name": "Caminho 946",
    d: "M33.1,191.427h-5.12a.718.718,0,0,0-.692.526,2.863,2.863,0,0,1-5.517,0,.718.718,0,0,0-.692-.526H1.921a.486.486,0,0,1-.485-.485V169.114a.718.718,0,0,0-1.436,0v21.827a1.924,1.924,0,0,0,1.921,1.921H20.574a4.3,4.3,0,0,0,7.918,0H33.1a.718.718,0,1,0,0-1.436Z",
    transform: "translate(0 -97.45)",
    fill: "#d4af37"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReadActivity);
export default __webpack_public_path__ + "static/media/readActivity.eabfe8070a485aa58c5d5ad73d05dba4.svg";
export { ForwardRef as ReactComponent };